import React, { useRef } from 'react';

const CashflowIframePage = () => {
  const iframeRef = useRef(null);

  const iframeSrc =
    window.location.hostname === 'localhost'
      ? 'http://localhost:3000/property-investment-calculators?embed=true&source=npc'
      : 'https://www.propsourcing.com.au/property-investment-calculators?embed=true&source=npc';

  return (
    <div className="min-h-screen p-6">
      <h1 className="text-2xl font-bold text-center mb-4 text-[#003366]">Cashflow Calculator</h1>
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="Cashflow Calculator"
        width="100%"
        height="1000"
        className="border rounded shadow"
      />
    </div>
  );
};

export default CashflowIframePage;
